import { Ref, ref } from 'vue'

export function useFixedHeader(
  scrollOffset: Ref<number>,
  scrollContainer: Ref<HTMLElement | undefined>
) {
  const isFixedHeader = ref(false)
  const scrollPercentage = ref(0)
  const isScrollable = ref(true)
  const bottomThresholdOffset = ref(0)

  const onContentScroll = () => {
    if (!scrollContainer.value) {
      return
    }

    const scrollTop = scrollContainer.value.scrollTop

    isFixedHeader.value = scrollTop > scrollOffset.value ? true : false

    const scrollHeight = scrollContainer.value.scrollHeight
    const clientHeight = scrollContainer.value.clientHeight

    scrollPercentage.value = (scrollTop / (scrollHeight - clientHeight)) * 100
    bottomThresholdOffset.value = Math.abs(
      scrollHeight - clientHeight - scrollTop
    )
    isScrollable.value = scrollHeight > clientHeight

    return {
      isFixedHeader: isFixedHeader.value,
      scrollPercentage: scrollPercentage.value,
      bottomThresholdOffset: bottomThresholdOffset.value,
    }
  }

  return {
    onContentScroll,
    isFixedHeader,
    scrollPercentage,
    isScrollable,
    bottomThresholdOffset,
  }
}
